import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppDataContext from '../common/AppContext';
import zIndex from '@material-ui/core/styles/zIndex';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '5px',
        display: 'flex',
        backgroundColor: 'black',
        zIndex: theme.zIndex.drawer + 1,
        borderRadius: theme.spacing(0),
    },
    copyright: {
        marginLeft: 'auto',
        color: "white"
    }

}));


const FooterBar = () => {
    const classes = useStyles();

    const { applicationVersion, leagueId, leagueName } = useContext(AppDataContext);

    const getFooterTextForLeague = () => {
        let year = new Date().getFullYear();
        switch (leagueId) {
            case "00":
                return `${year} ${leagueName} Properties, Inc.`;
            case "10":
                return `${year} ${leagueName} Enterprises, LLC.`;
            default:
                return `${year} ${leagueName} Properties, Inc.`;
        }
    }

    return (
        <Paper elevation={6} className={classes.root}>
            <Typography variant="caption" className={classes.copyright}>© {getFooterTextForLeague()} All rights reserved.</Typography>
        </Paper>
    )
}

export default FooterBar;